import { render, staticRenderFns } from "./LeadtributorSimple.vue?vue&type=template&id=b569eb28&scoped=true&"
import script from "./LeadtributorSimple.vue?vue&type=script&lang=js&"
export * from "./LeadtributorSimple.vue?vue&type=script&lang=js&"
import style0 from "./LeadtributorSimple.vue?vue&type=style&index=0&id=b569eb28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b569eb28",
  null
  
)

export default component.exports